import { faStar } from '@fortawesome/pro-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import React from 'react';
import { Flex } from '../../flayr-components/Flex/Flex';
import { StarRating } from '../../flayr-components/StarRating/StarRating';
import ReviewBadge from '../../lib/ReviewBadge/ReviewBadge';

interface IReviewsSummaryProps {
  items: { label: string; rating: number }[];
  className?: string;
  providerName?: string;
}

const ReviewsSummary: React.FC<React.PropsWithChildren<React.PropsWithChildren<IReviewsSummaryProps>>> = ({
  items,
  className,
  providerName,
}) => {
  function getLabel(label) {
    if (!label) return '';
    let text = label;
    if (typeof label === 'object') {
      text = label.default;
    }
    return text.replace(/{{providerName}}/g, providerName);
  }

  return (
    <div className={className}>
      {items.map(({ label, rating }, idx) => (
        <Flex x="between" className="mb-1 lg:mb-2 lg:text-xl" key={idx}>
          <span className="text-black capitalize">{getLabel(label)}</span>
          <ReviewBadge
            fontSizeClassName="lg:text-lg"
            starFontSizeClassName="lg:text-base"
            className="text-gray-primary"
            score={rating}
          />
        </Flex>
      ))}
    </div>
  );
};
export default ReviewsSummary;
